import { IconProps } from './types';

const FeedbackIcon: React.FC<IconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none">
      <path
        fill="#5E6C9A"
        d="M14 26c6.6274 0 12-5.3726 12-12 0-6.62742-5.3726-12-12-12C7.37258 2 2 7.37258 2 14c0 6.6274 5.37258 12 12 12Z"
      />
      <mask id="a" width="14" height="14" x="7" y="7" maskUnits="userSpaceOnUse">
        <path fill="#fff" d="M7 7h14v14H7z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#B6BEDA"
          d="M8.1665 19.8332V9.3915c0-.34027.1191-.62951.3573-.8677.23819-.2382.52743-.3573.8677-.3573h9.2167c.3403 0 .6295.1191.8677.3573.2382.23819.3573.52743.3573.8677v6.8833c0 .3403-.1191.6296-.3573.8677-.2382.2382-.5274.3573-.8677.3573h-8.1084l-2.3333 2.3334Z"
        />
      </g>
    </svg>
  );
};

export default FeedbackIcon;
